import {GetApplicationsResponse} from '@/types/Applications'
import {getApplicationsService} from '../services/applicationService'

export async function getApplicationsUseCase(signal?: AbortSignal): Promise<GetApplicationsResponse> {
  return getApplicationsService(signal)
}
